export default "./src/client/components/auth/login/open-web/spid-button/img/spid-idp-infocertid.svg?f0bd84b998462b48c0c4b7918683df27";